import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@material-ui/core';
import { useResourceRequest } from '~/modules/resourcing/hooks';
import ReleaseResourceDialogLoadingContent from './ReleaseResourceDialogLoadingContent';
import ReleaseResourceDialogContent from './ReleaseResourceDialogContent';

export const ReleaseResourceDialog = ({
  onCancelClick,
  open,
  canEditTask,
  onReleaseSuccess,
  onReleaseResourceAllocation,
  onReleaseResourceAllocationsForRequest,
  onResourceRequestSubmit,
  resourceRequest,
  allocation,
  projectUri
}) => {
  const { resourceRequest: request, isLoading } = useResourceRequest({
    resourceRequestId: allocation.resourceRequestId,
    skip: !allocation.resourceRequestId
  });

  return (
    <Dialog
      open={open}
      onClose={onCancelClick}
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="release-resource-dialog-title"
      aria-describedby="release-resource-dialog-content"
    >
      {isLoading ? (
        <ReleaseResourceDialogLoadingContent
          allocation={allocation}
          onCancelClick={onCancelClick}
        />
      ) : (
        <ReleaseResourceDialogContent
          canEditTask={canEditTask}
          onReleaseSuccess={onReleaseSuccess}
          onReleaseResourceAllocation={onReleaseResourceAllocation}
          onReleaseResourceAllocationsForRequest={
            onReleaseResourceAllocationsForRequest
          }
          onResourceRequestSubmit={onResourceRequestSubmit}
          resourceRequest={resourceRequest || request}
          allocation={allocation}
          projectUri={projectUri}
          onCancelClick={onCancelClick}
        />
      )}
    </Dialog>
  );
};

ReleaseResourceDialog.propTypes = {
  onCancelClick: PropTypes.func.isRequired,
  canEditTask: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  resourceRequest: PropTypes.object,
  projectUri: PropTypes.string,
  allocation: PropTypes.object,
  onReleaseSuccess: PropTypes.func,
  onResourceRequestSubmit: PropTypes.func,
  onReleaseResourceAllocation: PropTypes.func,
  onReleaseResourceAllocationsForRequest: PropTypes.func
};

export default ReleaseResourceDialog;
